import { useRouter } from 'next/dist/client/router';
import React from 'react';

import { useInstanceDetailPage } from '../../../../api/hooks/useInstanceDetail.hook';
import { ButtonVariantsEnum } from '../../../../utils/_enums/button-variants.enum';
import { RoutePath } from '../../../../utils/_enums/route-path.enum';
import { TypographyVariantsEnum } from '../../../../utils/_enums/typeography-variants.enum';
import { useAppSelector } from '../../../../utils/_hooks/hooks';
import { Button } from '../../button/button';
import { Typography } from '../../typography/typography';
import WalletConnectButton from '../../wallet-connect-button/wallet-connect-button';
import styles from './not-available-nft.module.scss';

const NotAvailableNft = () => {
    const data = useInstanceDetailPage();
    const jwt = useAppSelector((state) => state.authentification.jwt);
    const walletId = useAppSelector((state) => state.blockchainSlice.walletId);
    const router = useRouter();

    if (data) {
        return (
            <div className={styles['not-available-nft']}>
                <Typography>
                    {data?.notAvailableMessage?.content ?? ''}
                </Typography>
                <div className={styles['lower-wrapper']}>
                    {!jwt ? (
                        <div className={styles['not-available-box']}>
                            <Typography
                                variant={TypographyVariantsEnum.HEADING5}
                                className={styles['not-available-headline']}
                                element={'span'}
                            >
                                {data?.onLoginHeadline?.headlineContent ?? ''}
                            </Typography>
                            <Typography
                                variant={TypographyVariantsEnum.BODY}
                                element={'span'}
                            >
                                {data?.onLoginDescription?.content ?? ''}
                            </Typography>
                            <Button
                                className={styles['first-button']}
                                onClick={() => router.push(RoutePath.LOGIN)}
                            >
                                {data?.loginButton?.buttonText ?? ''}
                            </Button>
                            <Button
                                className={styles['last-button']}
                                onClick={() => router.push(RoutePath.REGISTER)}
                                variant={ButtonVariantsEnum.SECONDARY_OUTLINED}
                            >
                                {data?.registerButton?.buttonText ?? ''}
                            </Button>
                        </div>
                    ) : undefined}
                    {!walletId ? (
                        <div className={styles['not-available-box']}>
                            <Typography
                                variant={TypographyVariantsEnum.HEADING5}
                                className={styles['not-available-headline']}
                                element={'span'}
                            >
                                {data?.onConnectWithWalletHeadline
                                    ?.headlineContent ?? ''}
                            </Typography>
                            <Typography
                                variant={TypographyVariantsEnum.BODY}
                                element={'span'}
                            >
                                {data?.onWalletConnectDescription?.content ??
                                    ''}
                            </Typography>
                            <WalletConnectButton
                                className={styles['first-button']}
                            />
                        </div>
                    ) : undefined}
                </div>
            </div>
        );
    } else {
        return <div />;
    }
};

export default NotAvailableNft;
